







import Vue from 'vue'

type Props = {
  heading: string | null
  ingredients: Array<string>
}
type Computed = {
  label: string
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'Ingredients',
  props: {
    heading: {
      type: String,
      default: null,
    },
    ingredients: {
      type: Array,
      required: true,
    },
  },
  computed: {
    label() {
      if (this.ingredients.length === 0) {
        return this.$tc('common.none')
      }
      return this.ingredients.join('、')
    },
  },
})
